import React from "react";
import { styled } from "@acko-tech/building-blocks.ui.common";
import Icon from "@widgets/Icon";
import { connect } from "react-redux";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { useEffect } from "react";

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

export const Container = styled.div`
  background-color: white;
  width: 100%;
  height: 94vh;
  margin-top: -44px;
  @media (min-width: 769px) {
    height: 424px;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Text = styled.p`
  font-family: Euclid Circular B;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.10000000149011612px;
  text-align: center;
  color: #0b753e;
  margin: 0;
`;

const DetailsAddedLoader = ({ is_visible, text, actions }: any) => {
  if (!is_visible) return <></>;

  useEffect(() => {
    actions?.on_load?.forEach((func: any) => {
      func?.funCall?.();
    });
  }, []);

  return (
    <Container>
      <Icon
        overrideIsVisible={true}
        path={"/images/gif/tick-sign.gif"}
        styles={{ width: "200px" }}
      />
      <Text>{text}</Text>
    </Container>
  );
};

export default connect(mapStateToProps)(DetailsAddedLoader);
